function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { memorialListApi, memorialSaveApi, memorialEditApi, memorialDeleteApi, memorialGroupApi } from '@/api/user';
import fSpan from '@/views/business/components/formSetting/components/form-create-designer/src/config/rule/span';
export default {
  name: 'Notepad',
  components: {
    fSpan: fSpan,
    menuTree: function menuTree() {
      return import('./components/menuTree');
    },
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    moveDialog: function moveDialog() {
      return import('./components/moveDialog');
    }
  },
  props: {
    style1: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      treeData: [],
      loadingPage: false,
      recently: false,
      recentlyList: [],
      goodData: {
        file_name: '',
        cate_id: '',
        page: 1,
        limit: 20,
        title: ''
      },
      total: 0,
      id: null,
      // 文件id
      pid: null,
      // 文件夹id
      itemIndex: null,
      content: '',
      title: '',
      memorandum: [],
      saveLoading: false,
      tabButton: false,
      moveData: {},
      timer: null
    };
  },
  mounted: function mounted() {
    this.createdEvent();
  },
  beforeDestroy: function beforeDestroy() {
    this.handleRemove();
  },
  watch: {
    content: {
      handler: function handler(val, oldVal) {
        this.autoSave();
      },
      deep: true //true 深度监听
    }
  },
  methods: {
    autoSave: function autoSave(val, oldVal) {
      var _this = this;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(function () {
        _this.edit('auto');
      }, 30000);
    },
    handleRemove: function handleRemove() {
      document.removeEventListener('keydown', this.handleEvent); // 在页面销毁的时候记得解除
    },
    createdEvent: function createdEvent() {
      document.addEventListener('keydown', this.handleEvent);
    },
    handleEvent: function handleEvent(event) {
      if (event.ctrlKey || event.metaKey) {
        if (event.code === 'KeyS') {
          event.preventDefault();
          // 在这里写保存需要执行的逻辑
          this.edit();
        }
      }
    },
    getFrameId: function getFrameId(e) {
      this.recently = false;
      this.memorandum = [];
      this.goodData.cate_id = e;
      this.goodData.page = 1;
      this.tableList();
    },
    clickItem: function clickItem(index, id, i, pid) {
      var _this2 = this;
      if (this.recently) {
        this.itemIndex = id;
        this.pid = pid;
      } else {
        this.itemIndex = index;
      }
      this.id = id;
      if (this.memorandum.length > 0) {
        setTimeout(function () {
          // 最近访问
          if (_this2.recently) {
            _this2.content = _this2.memorandum[i].data[index].content;
            _this2.title = _this2.memorandum[i].data[index].title;
          } else {
            _this2.content = _this2.memorandum[index].content;
            _this2.title = _this2.memorandum[index].title;
          }
        }, 300);
      }
    },
    // 最近使用
    onRecently: function onRecently() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.loadingPage = true;
              _context.next = 3;
              return memorialGroupApi({
                title: _this3.goodData.title
              });
            case 3:
              res = _context.sent;
              _this3.recently = true;
              _this3.loadingPage = false;
              _this3.memorandum = res.data.list;
              if (_this3.memorandum.length > 0) {
                _this3.clickItem(0, _this3.memorandum[0].data[0].id, 0, _this3.memorandum[0].data[0].pid);
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    tableList: function tableList() {
      var _this4 = this;
      var data = {
        page: this.goodData.page,
        limit: this.goodData.limit,
        pid: this.goodData.cate_id === 0 ? '' : this.goodData.cate_id,
        title: this.goodData.title
      };
      this.loadingPage = true;
      memorialListApi(data).then(function (res) {
        _this4.loadingPage = false;
        _this4.memorandum = res.data.list;
        if (_this4.memorandum.length > 0) {
          _this4.clickItem(0, _this4.memorandum[0].id);
        } else {
          _this4.content = '';
          _this4.title = '';
          _this4.itemIndex = null;
        }
      });
    },
    loadMore: function loadMore() {
      if (this.goodData.page <= this.total) {
        this.goodData.page++;
        this.tableList();
      }
    },
    changeSearch: function changeSearch() {
      this.recently ? this.onRecently() : this.tableList();
    },
    addMemorandum: function addMemorandum() {
      var data = {
        title: this.$t('calendar.placeholder03'),
        content: this.$t('calendar.placeholder04'),
        pid: this.goodData.cate_id || 0
      };
      this.addCreate(data);
    },
    // 创建内容
    addCreate: function addCreate(data) {
      var _this5 = this;
      var Flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (Flag) {
        this.saveLoading = true;
      }
      memorialSaveApi(data).then(function (res) {
        if (Flag) {
          _this5.saveLoading = false;
        }
        _this5.tableList();
        _this5.$refs.menuTree.menuList();
      }).catch(function (err) {
        if (Flag) {
          _this5.saveLoading = false;
        }
        _this5.$message.error(err.message);
      });
    },
    // 修改
    edit: function edit(val) {
      if (this.title == '') {
        this.$message.error(this.$t('calendar.placeholder05'));
      } else if (this.content == '') {
        this.$message.error(this.$t('calendar.placeholder06'));
      } else {
        if (this.itemIndex != null) {
          var data = {
            title: this.title,
            content: this.content
          };
          // 编辑
          if (this.memorandum.length > 0) {
            if (this.recently) {
              data.pid = this.pid;
              this.id = this.itemIndex;
            } else {
              data.pid = this.memorandum[this.itemIndex].pid;
            }
            this.memorialEdit(this.id, data, val);
          } else {
            data.pid = this.goodData.cate_id === '' ? 0 : this.goodData.cate_id;
            this.addCreate(data, true);
          }
        }
      }
    },
    // 编辑
    memorialEdit: function memorialEdit(id, data, val) {
      var _this6 = this;
      this.saveLoading = true;
      memorialEditApi(id, data).then(function (res) {
        if (res.status == '200' && val !== 'auto') {
          _this6.$message.success('修改成功');
        }
        _this6.saveLoading = false;
        if (_this6.recently) {
          _this6.onRecently();
        } else {
          _this6.tableList();
        }
      }).catch(function (err) {
        _this6.saveLoading = false;
      });
    },
    editTitle: function editTitle(e) {
      if (this.itemIndex === null) return false;
      if (this.title === '') {
        this.title = this.memorandum[this.itemIndex].title;
      } else {
        this.memorandum[this.itemIndex].title = e;
      }
    },
    getStringHtml: function getStringHtml(text) {
      var reg = /<[^<>]+>/g;
      text = text.replace(reg, '');
      text = text.replace(/&nbsp;/gi, '');
      return text;
    },
    ueditorEdit: function ueditorEdit(e) {
      if (this.itemIndex === null) return false;
      if (this.memorandum.length > 0 && !this.recently) {
        if (e) {
          this.memorandum[this.itemIndex].content = e;
          this.content = e;
        }
      } else {
        this.content = e;
      }
    },
    // 删除
    delMemorandum: function delMemorandum() {
      var _this7 = this;
      if (this.itemIndex === null) return false;
      this.$modalSure(this.$t('calendar.placeholder07')).then(function () {
        memorialDeleteApi(_this7.id).then(function (res) {
          if (!_this7.recently) {
            _this7.$refs.menuTree.menuList();
            _this7.tableList();
          } else {
            _this7.onRecently();
          }
        });
      });
    },
    moveTo: function moveTo(item) {
      this.moveData.data = item;
      this.$refs.moveDialog.handleOpen();
    },
    handlerMove: function handlerMove() {
      this.tableList();
      this.$refs.menuTree.menuList();
    }
  }
};